import { ActionLogsActions, ChangeLogSearchAction, ChangeSelectedLogAction, FetchLogsAction, ActionLogsTypes } from '../../actions/actionLogs'
import initialState, { ActionLogsState } from './state'
import { ActionLog } from '../../types'

function actionLogsReducer(state: ActionLogsState = initialState, action: ActionLogsActions): ActionLogsState {
    switch (action.type) {
        case ActionLogsTypes.LOGS_FETCH_SUCCESS: {
            const { payload, meta } = action as FetchLogsAction
            const data: ActionLog[] = payload?.data
            const pagination: Boolean = meta?.pagination || false
            const noFirstPage: Boolean = meta?.noFirstPage || false

            if (pagination)
                return {
                    ...state,
                    logs: noFirstPage ? [...state.logs, ...data] : data,
                    pagination: {
                        currentPage: payload.current_page,
                        perPage: payload.per_page,
                        total: payload.total,
                        from: payload.from,
                        to: payload.to,
                    },
                }
            return {
                ...state,
                logs: data,
                pagination: {
                    currentPage: 1,
                    perPage: 0,
                    total: 0,
                    from: 0,
                    to: 0,
                },
            }
        }
        case ActionLogsTypes.CHANGE_LOG_SEARCH: {
            const { payload } = action as ChangeLogSearchAction
            const { search } = payload || {}
            return {
                ...state,
                search,
            }
        }
        case ActionLogsTypes.CHANGE_SELECTED_LOG: {
            const { payload } = action as ChangeSelectedLogAction
            const value: ActionLog = payload?.value

            return {
                ...state,
                selectedLog: value,
            }
        }
        default:
            return state
    }
}

export default actionLogsReducer
